import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetClaimablePaymentRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetClaimablePaymentResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getClaimablePayment = (request: GetClaimablePaymentRequest, options?: CashRequestOptions) =>
  post<GetClaimablePaymentRequest, GetClaimablePaymentResponse>('/2.0/cash/get-claimable-payment', request, {
    ...options,
    rejectOnError: true,
  })
